import { render, staticRenderFns } from "./PreciosForm.vue?vue&type=template&id=95666c5a&"
import script from "./PreciosForm.vue?vue&type=script&lang=js&"
export * from "./PreciosForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports